import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconColor, IconImage, IconSize } from '@interfaces/common.interface';

@Component({
  selector: 'ark-card-checkbox',
  templateUrl: './card-checkbox.component.html',
  styleUrls: ['./card-checkbox.component.scss'],
})
export class CardCheckboxComponent {
  @Input() size: 'small' | 'large' | 'tiny' = 'small';

  @Input() label: string | null = null;
  @Input() description: string | null = null;
  @Input() checked = false;
  @Input() disabled = false;

  @Input() icon: IconImage = 'close';
  @Input() iconColor: IconColor = 'confirm';
  @Input() iconSize: IconSize = 'large';

  @Output() selectionChanged = new EventEmitter<{
    label: string | null;
    checked: boolean;
  }>();

  @Input() tickIcon: IconImage = 'tick';
  tickIconColor: IconColor = 'light';
  tickIconSize: IconSize = 'small';
  constructor() {}

  select(): void {
    this.checked = !this.checked;
    this.selectionChanged.emit({
      label: this.label,
      checked: this.checked,
    });
  }
}
